import {useState, useEffect} from 'react';

const useAudio = url => {
  const [audio, setAudio] = useState(new Audio(""));

  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    if (url) {
      setAudio(new Audio(url));
      setPlaying(true);
    }
  }, [url]);

  useEffect(() => {
      (playing && url) ? audio.play() : audio.pause();
      return () => {
        audio.pause();
      }
    },
    [playing, audio, url]
  );

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, [audio]);

  return [playing, toggle];
};

export default useAudio;